import API from './api';

export default class Jump extends API {
  constructor(config = {}) {
    config.path = `quizzes/${config.quizId}/steps/${config.stepId}/jumps`;

    super(config);
  }
}



/** WEBPACK FOOTER **
 ** ./src/helpers/request/jump.js
 **/